module.exports = /*html*/ `
<div v-if="isopen" id="ig-popup" :class="{'show': isopen}" >
	<div class="popup-inner">
        <div class="popup-control">
	        <a @click.prevent="goPost('pre')" class="d-inline-block mx-3" href="#"><i class="icon-arrow-left"></i></a>
	        <a @click.prevent="goPost('next')" class="d-inline-block mx-3" href="#"><i class="icon-arrow-right"></i></a>
	        <a @click.prevent="closePopup" class="d-inline-block mx-3" href="#"><i class="icon-close"></i></a>
        </div>
        <div class="row m-0">
            <div class="popup-img-box col-md-6 col-12">
                <div class="popup-img" :style="'background-image: url('+item.Cover+');'"></div>
            </div>
            <div class="popup-info col-md-6 col-12">
				<div class="mb-5">
					<span style="font-size: 29px;">#hotgirldiscount</span>
					<div class="h4">
						<i class="icon-ig2"></i>
						<a class="d-inline-block align-middle ml-2" :href="item.Url" target="_blank">@{{item.Owner.UserName}}</a>
					</div>
                </div>
                <div class="item-list-box">
                	<Slick
				      v-if="item.MarketColors.length>0"
				      class="product-slide"
				      ref="slickig"
				      :options = "slideOpts"
				      @afterChange="handleAfterChange"
				      @beforeChange="handleBeforeChange"
				      @breakpoint="handleBreakpoint"
				      @destroy="handleDestroy"
				      @edge="handleEdge"
				      @init="handleInit"
				      @reInit="handleReInit"
				      @setPosition="handleSetPosition"
				      @swipe="handleSwipe"
				      @lazyLoaded="handleLazyLoaded"
				      @lazyLoadError="handleLazeLoadError">
				      <div v-for="(market, index) in item.MarketColors" class="item-box" :key="market.ID">
                        <div class="inner">
                            <div class="item-img-box">
	                            <a :href="market.Url">
	                            	<new-image :url="market.MarketCover" :size="'_w594_h594'" :name="market.MarketName"></new-image>
	                            </a>
                            </div>
                            <div class="item-info text-center">
                                <div class="item-name"><a :href="market.Url">{{market.MarketName}}</a></div>
                                <div class="item-price">
	                                <span v-if="market.SellPrice !== market.OriginPrice" class="d-inline-block mr-2 origin-price">NT$ {{market.OriginPrice}}</span>
	                                <span class="sell-price">NT$ {{market.SellPrice}}</span>
                                </div>
                            </div>
                        </div>
                       </div>
				    </Slick>
                </div>
            </div>
        </div>
    </div>
</div>
`;
